import React, {useEffect, useRef, useState} from 'react';
import {Alert, Button, Modal, message} from 'antd';
import api from '../authentication/axiosInstance';

export default function ResendUnansweredButton({filters, onComplete}) {
  const [preview,setPreview] = useState(null);
  const [busy,setBusy] = useState(false);
  const [job,setJob] = useState(null);
  const [error,setError] = useState('');
  const locked = useRef(false);
  const completed = useRef(onComplete);
  completed.current = onComplete;
  useEffect(() => {
    if (!job) return undefined;
    let stopped = false;
    let timer;
    const poll = async () => {
      try {
        const {data} = await api.get('/dispatch/resend-unanswered/',{params:{id:job}});
        if (stopped) return;
        if (data.finished) {
          message.info(`${data.resent} resend attempts completed; ${data.skipped} skipped; ${data.failed} failed.`);
          setJob(null);
          if (completed.current) completed.current();
          return;
        }
      } catch (err) {
        if (stopped) return;
        setError('Could not check resend progress. Sending may still be running; avoid starting another batch.');
      }
      timer = setTimeout(poll,3000);
    };
    poll();
    return () => {stopped=true;clearTimeout(timer);};
  },[job]);
  const open = async () => {
    if (locked.current || job) return;
    locked.current = true;
    setBusy(true);
    setError('');
    try {
      const {data} = await api.post('/dispatch/resend-unanswered/',{...filters,action:'preview'});
      setPreview(data);
    } catch (err) {message.error('Could not load unanswered messages. Please try again.');}
    finally {locked.current=false;setBusy(false);}
  };
  const send = async () => {
    if (locked.current || !preview?.count) return;
    locked.current=true;
    setBusy(true);
    setError('');
    try {
      const {data} = await api.post('/dispatch/resend-unanswered/',{action:'send',token:preview.token});
      setJob(data.id);
      setPreview(null);
    } catch (err) {setError(err.response?.data?.detail || 'Could not confirm the resend. Retry here to avoid duplicates.');}
    finally {locked.current=false;setBusy(false);}
  };
  return <>
    <Button onClick={open} loading={busy || Boolean(job)} disabled={Boolean(preview) || Boolean(job)}>Resend all unanswered</Button>
    {job && error && <Alert type="warning" message={error} />}
    <Modal title="Resend all unanswered" open={Boolean(preview)} onOk={send}
      onCancel={() => {if (!locked.current) setPreview(null);}} okText="Resend" cancelText="Cancel"
      confirmLoading={busy} okButtonProps={{disabled:!preview?.count}} cancelButtonProps={{disabled:busy}}
      closable={!busy} keyboard={!busy} maskClosable={!busy}>
      <p>Resend {preview?.count || 0} unanswered messages matching the current filters, across all pages?</p>
      <p>Staff who have confirmed or declined are skipped. Closed, expired and replaced messages are skipped too. Answers received after this preview are checked again before sending.</p>
      <p>Delivery uses the existing push, email and applicable messaging channels. A resend attempt does not guarantee phone delivery.</p>
      {error && <Alert type="error" message={error} />}
    </Modal>
  </>;
}
